// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1h--T","productName":"Table_productName__2MGOS"};